import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { TestIds } from '@investown/fe/test-utils/testIds';

import InvisibleButton from 'components/InvisibleButton';
import LogoutOutlineIcon from 'components/Icons/LogoutOutlineIcon';
import SpacerHorizontalDeprecated from 'components/SpacerHorizontalDeprecated';
import useLogout from 'hooks/useLogout';

const LogoutButton: FC<{ showIcon?: boolean }> = ({ showIcon = false }) => {
  const { formatMessage } = useIntl();
  const logout = useLogout();

  const onLogout = useCallback(async () => {
    await logout({ afterLogoutMessage: formatMessage({ id: 'signOut.success' }) });
  }, [formatMessage, logout]);

  return (
    <InvisibleButton onClick={onLogout} data-testid={TestIds.UserMenuLogoutButton}>
      {showIcon && (
        <>
          <LogoutOutlineIcon />
          <SpacerHorizontalDeprecated width="medium" />
        </>
      )}
      {formatMessage({ id: 'topbar.user.dropdown.logout' })}
    </InvisibleButton>
  );
};

export default LogoutButton;
